'use client';
import React from 'react';

interface Props {
  setDialogMode: (dialog: boolean) => void;
  updateHeight: () => void;
}

export const TickerContext = React.createContext<Props>({
  setDialogMode: () => undefined,
  updateHeight: () => undefined,
});

export const TickerContextProvider: React.FC<React.PropsWithChildren<Props>> = props => {
  return (
    <TickerContext.Provider
      value={{
        setDialogMode: props.setDialogMode ?? (() => undefined),
        updateHeight: props.updateHeight ?? (() => undefined),
      }}
    >
      {props.children}
    </TickerContext.Provider>
  );
};
